import { render } from "./ShortcutHelp.vue?vue&type=template&id=958bd184"
import script from "./ShortcutHelp.vue?vue&type=script&lang=js"
export * from "./ShortcutHelp.vue?vue&type=script&lang=js"

import "./ShortcutHelp.vue?vue&type=style&index=0&id=958bd184&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__